import axios from 'axios'
import NProgress from 'nprogress'
import { notification } from 'antd'
import { store } from 'index'
import {
  API_URL,
  API_URL_WORKORDER,
  API_URL_REPORT,
  API_URL_INVENTORY,
  NETWORK_ERROR,
  NETWORK_ERROR_MESSAGE,
  API_URL_PRINT,
} from '../constants/index'

const token = localStorage.getItem('token')
const locale = localStorage.getItem('locale')

const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'accept-language': locale?.replace('"', '').substring(0, 2),
  },
}

const netWorkErrorNotification = () => {
  notification.error({
    message: NETWORK_ERROR,
    duration: 0,
    description: NETWORK_ERROR_MESSAGE,
  })
}

const errorNotificationUnknown2 = message => {
  notification.error({
    message: '',
    description: message,
    duration: 0,
  })
}

export const getWorkorderID = () => {
  const state = store.getState()
  return state &&
    state.workOrders &&
    state.workOrders.editing &&
    state.workOrders.editing.workOrderID
    ? state.workOrders.editing.workOrderID
    : '0'
}

export const getInventoryID = () => {
  const state = store.getState()
  return state &&
    state.inventorys &&
    state.inventorys.editing &&
    state.inventorys.editing.inventoryID
    ? state.inventorys.editing.inventoryID
    : '0'
}

export const getInventoryNumber = () => {
  const state = store.getState()
  return state &&
    state.inventorys &&
    state.inventorys.editing &&
    state.inventorys.editing.inventoryNumber
    ? state.inventorys.editing.inventoryNumber
    : '0'
}

export const getContractAppType = () => {
  const state = store.getState()
  return state && state.contracts && state.contracts.selected && state.contracts.selected.payload
    ? state.contracts.selected.payload.appType
    : ''
}

export const getcompanyIdNumber = () => {
  const state = store.getState()
  return state && state.companys && state.companys.selected && state.companys.selected.payload
    ? state.companys.selected.payload.companyID
    : ''
}

export const getcontractIdNumber = () => {
  const state = store.getState()
  return state && state.contracts && state.contracts.selected && state.contracts.selected.payload
    ? state.contracts.selected.payload.contractID
    : localStorage.getItem('contractID')
}

// Attach the currently selected contract to every request - the backend's
// user-activity audit reads this header to attribute actions to a project.
// The redux store is the canonical source; localStorage 'contractID' alone is
// only populated by a grid double-click and misses most selection flows.
axios.interceptors.request.use(cfg => {
  const cid = getcontractIdNumber()
  if (cid) {
    // eslint-disable-next-line no-param-reassign
    cfg.headers = { ...cfg.headers, 'X-Contract-ID': cid }
  }
  return cfg
})

export const getInvoice2ID = () => {
  const state = store.getState()
  return state && state.invoice2s && state.invoice2s.editing && state.invoice2s.editing.invoiceID
    ? state.invoice2s.editing.invoiceID
    : ''
}

export const getAreaID = () => {
  const state = store.getState()
  return state && state.iventorys && state.iventorys.editing && state.iventorys.editing.areaID
    ? state.iventorys.editing.areaID
    : ''
}

export const getPartOrderID = () => {
  const state = store.getState()
  return state &&
    state.partOrders &&
    state.partOrders.editing &&
    state.partOrders.editing.partOrderID
    ? state.partOrders.editing.partOrderID
    : '0'
}

export const getPartTransferID = () => {
  const state = store.getState()
  return state &&
    state.partTransfers &&
    state.partTransfers.editing &&
    state.partTransfers.editing.partTransferID
    ? state.partTransfers.editing.partTransferID
    : '0'
}

// The proposal the user is LOOKING AT. On the proposal page (/proposals/:id) and the
// approval screen (/proposalApprovement/:id) that is the id in the address: the proposal
// in the store can still be the previously opened one while the new page loads, and its
// materials / hours / travel costs then showed up on the new proposal.
const proposalIdOfPage = () => {
  const match = window.location.pathname.match(/^\/(proposals|proposalApprovement)\/(\d+)/)
  return match ? match[2] : null
}

export const getProposalID = () => {
  const fromPage = proposalIdOfPage()
  if (fromPage !== null) {
    return fromPage
  }
  const state = store.getState()
  return state && state.proposals && state.proposals.editing && state.proposals.editing.proposalID
    ? state.proposals.editing.proposalID
    : '0'
}

export const getInvoiceID = () => {
  const state = store.getState()
  return state && state.invoices && state.invoices.editing && state.invoices.editing.invoiceID
    ? state.invoices.editing.invoiceID
    : '0'
}

export const getProposalWorkOrderID = () => {
  const state = store.getState()
  const proposalID =
    state?.proposals?.editing?.workOrderID || state?.proposals?.editing?.workorderID
  if (proposalID) {
    return proposalID
  }

  const workOrderID = state?.workOrders?.editing?.workOrderID
  if (workOrderID) {
    return workOrderID
  }

  return '0'
}

export const getContractPartnerID = () => {
  const state = store.getState()
  return state &&
    state.contractPartners &&
    state.contractPartners.editing &&
    state.contractPartners.editing.contractPartnerID
    ? state.contractPartners.editing.contractPartnerID
    : '0'
}

export const getContractInvoicePartnerID = () => {
  const state = store.getState()
  return state &&
    state.contractInvoicePartners &&
    state.contractInvoicePartners.editing &&
    state.contractInvoicePartners.editing.contractInvoicePartnerID
    ? state.contractInvoicePartners.editing.contractInvoicePartnerID
    : '0'
}

export const getContractServicePartnerID = () => {
  const state = store.getState()
  return state &&
    state.contractServicePartners &&
    state.contractServicePartners.editing &&
    state.contractServicePartners.editing.contractServicePartnerID
    ? state.contractServicePartners.editing.contractServicePartnerID
    : '0'
}

const errorNotificationUnknown = message => {
  notification.error({
    message: NETWORK_ERROR,
    description: message,
    duration: 0,
  })
}

const errorNotification403 = (responseData) => {
  const lang = localStorage.getItem('app.settings.locale') || 'en-US'
  const msg = lang === 'de-DE' ? 'Zugriff verweigert' : 'Access Denied'
  let desc = lang === 'de-DE'
    ? 'Sie haben nicht die erforderlichen Berechtigungen, um diese Aktion auszuführen. Bitte wenden Sie sich an Ihren Administrator.'
    : 'You do not have the necessary permissions to perform this action. Please contact your administrator.'
  if (responseData && responseData.requiredPermission) {
    desc += ` (${responseData.requiredPermission})`
  }
  notification.error({
    message: msg,
    description: desc,
    duration: 5,
  })
}

export const getMicroBaseApiUrl = url => {
  // eslint-disable-next-line no-underscore-dangle
  let _url = API_URL
  if (url.startsWith('dropdown')) {
    _url = API_URL
  } else if (url.startsWith('workOrder')) {
    console.log('getMicroBaseApiUrl workOrder')
    _url = API_URL_WORKORDER
  } else if (
    url.startsWith('costType') ||
    url.startsWith('inventory') ||
    url.startsWith('device')
  ) {
    _url = API_URL_INVENTORY
  } else if (url.startsWith('report')) {
    _url = API_URL_REPORT
  } else if (url.startsWith('token')) {
    _url = API_URL
  }
  return _url
}

export async function downloadRequest(url) {
  if (url.includes('http')) {
    window.open(url)
    return
  }
  window.open(`${getMicroBaseApiUrl(url)}${url}`)
}

export async function getRequestReportViewer(url) {
  try {
    if (url.includes('http')) {
      const response = await axios.get(url, config)
      return response.data
    }

    const response = await axios.get(`${API_URL_PRINT}${url}`, config)
    return response.data
  } catch (error) {
    if (error.response) {
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
    }
    return null
  }
}

export async function getRequest(url) {
  try {
    if (url.includes('http')) {
      const response = await axios.get(url, config)
      return response.data
    }

    const response = await axios.get(`${getMicroBaseApiUrl(url)}${url}`, config)
    // Success 🎉
    return response.data
  } catch (error) {
    console.error(error)
    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)

      if (error.response.status === 401) {
        // unauthorized
        localStorage.removeItem('token')
        window.location.href = '/login'
      } else if (error.response.status === 403) {
        // forbidden - insufficient permissions
        errorNotification403(error.response?.data)
      } else if (error.response.status === 500) {
        // server error
        errorNotificationUnknown(error.response.data.title)
      } else if (error.response.status === 400) {
        // bad request
        if (typeof error.response.data === 'string' || error.response.data instanceof String) {
          errorNotificationUnknown2(error.response.data)
        } else {
          errorNotificationUnknown2(error.message)
        }
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(error.request)
      errorNotificationUnknown(error.message)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }

    if (error.message === 'Network Error' && (!error.response || error.response.status !== 403)) {
      netWorkErrorNotification()
    }

    return null
  }
}

export async function uploadWorkOrderFile(url, workOrderID, contractID, file) {
  const data = new FormData()
  data.append('ContractID', contractID)
  data.append('OrderNumber', workOrderID)
  data.append('File', file)
  const config2 = config
  // config2.headers['Content-Type'] = 'multipart/form-data'
  try {
    if (url.includes('http')) {
      const response = await axios.post(url, data, config2)
      return response.data
    }

    const response = await axios.post(url, data, config2)
    return response.data
  } catch (error) {
    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      if (typeof error.response.data === 'string' || error.response.data instanceof String) {
        if (error.response.status === 400) {
          errorNotificationUnknown2(error.response.data)
        } else {
          errorNotificationUnknown(error.response.data)
        }
      } else {
        errorNotificationUnknown(error.message)
      }
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      if (error.response.status === 401) {
        localStorage.removeItem('token')
        window.location.href = '/login'
      } else if (error.response.status === 403) {
        errorNotification403(error.response?.data)
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(error.request)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }
    if (error.message === 'Network Error') {
      if (error.response.status !== 401) {
        window.location.href = '/login'
        netWorkErrorNotification()
      }
    }
    return null
  }
}

export async function uploadPartOrderDocument(url, partOrderID, file) {
  const data = new FormData()
  data.append('OrderNumber', partOrderID)
  data.append('File', file)
  const config2 = config
  // config2.headers['Content-Type'] = 'multipart/form-data'
  try {
    if (url.includes('http')) {
      const response = await axios.post(url, config, config2)
      return response.data
    }

    const response = await axios.post(url, data, config2)
    return response.data
  } catch (error) {
    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      if (typeof error.response.data === 'string' || error.response.data instanceof String) {
        if (error.response.status === 400) {
          errorNotificationUnknown2(error.response.data)
        } else {
          errorNotificationUnknown(error.response.data)
        }
      } else {
        errorNotificationUnknown(error.message)
      }
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      if (error.response.status === 401) {
        localStorage.removeItem('token')
        window.location.href = '/login'
      } else if (error.response.status === 403) {
        errorNotification403(error.response?.data)
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(error.request)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }
    if (error.message === 'Network Error') {
      if (error.response.status !== 401) {
        window.location.href = '/login'

        netWorkErrorNotification()
      }
    }
    return null
  }
}

export async function uploadPartFile(url, number, file) {
  const data = new FormData()
  data.append('OrderNumber', number)
  data.append('File', file)
  const config2 = config
  // config2.headers['Content-Type'] = 'multipart/form-data'
  try {
    if (url.includes('http')) {
      const response = await axios.post(url, config, config2)
      return response.data
    }

    const response = await axios.post(url, data, config2)
    return response.data
  } catch (error) {
    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      if (typeof error.response.data === 'string' || error.response.data instanceof String) {
        if (error.response.status === 400) {
          errorNotificationUnknown2(error.response.data)
        } else {
          errorNotificationUnknown(error.response.data)
        }
      } else {
        errorNotificationUnknown(error.message)
      }
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      if (error.response.status === 401) {
        localStorage.removeItem('token')
      } else if (error.response.status === 403) {
        errorNotification403(error.response?.data)
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(error.request)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }
    if (error.message === 'Network Error') {
      if (error.response.status !== 401) {
        netWorkErrorNotification()
      }
    }
    return null
  }
}

export async function uploadProposalFile(url, file) {
  console.log('uploadProposalFile', url, file)
  const data = new FormData()
  data.append('OrderNumber', '')
  data.append('File', file)

  const config2 = config
  // config2.headers['Content-Type'] = 'multipart/form-data'
  try {
    if (url.includes('http')) {
      const response = await axios.post(url, data, config2)
      return response.data
    }

    const response = await axios.post(url, data, config2)
    return response.data
  } catch (error) {
    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      if (typeof error.response.data === 'string' || error.response.data instanceof String) {
        if (error.response.status === 400) {
          errorNotificationUnknown2(error.response.data)
        } else {
          errorNotificationUnknown(error.response.data)
        }
      } else {
        errorNotificationUnknown(error.message)
      }
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      if (error.response.status === 401) {
        localStorage.removeItem('token')
      } else if (error.response.status === 403) {
        errorNotification403(error.response?.data)
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(error.request)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }
    if (error.message === 'Network Error') {
      if (error.response.status !== 401) {
        netWorkErrorNotification()
      }
    }
    return null
  }
}

export async function postRequest(url, param, customHeader) {
  console.log('postRequest', url, param, customHeader)
  // Custom headers (e.g. multipart for an import) apply to THIS request only. Merging them
  // into the shared config made every later JSON post claim multipart ("Missing
  // content-type boundary" on e.g. saving a new inventory after an import).
  const requestConfig = customHeader
    ? { ...config, headers: { ...config.headers, ...customHeader } }
    : config
  try {
    if (url.includes('http')) {
      const response = await axios.post(url, param.values, requestConfig)
      return response.data
    }

    const response = await axios.post(
      `${getMicroBaseApiUrl(url)}${url}`,
      param.values,
      requestConfig,
    )
    // Success 🎉
    return response.data
  } catch (error) {
    console.error(error)
    console.log(error.response)
    console.log(error.request)

    if (error.response === undefined) {
      notification.error({
        duration: 0,
        message: 'Error',
        description: error.message,
      })
      return null
    }

    // 400error ise serviceResponse<T> donuyor. sagada handle ediliyor.
    if (error.response.status === 400) {
      if (error.response.data.traceId) {
        /*
        {
          "errors": {
              "mvst": [
                  "Could not convert string to integer: sd. Path 'mvst', line 1, position 214."
              ]
          },
          "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
          "title": "One or more validation errors occurred.",
          "status": 400,
          "traceId": "00-ed103aea8665e2882f8933c3f49e2cf8-464ded3be485d480-00"
        }
        */
        console.log('error.response.data.errors', error.response.data.errors)
        notification.error({
          duration: 0,
          message: error.response.data.title,
          description: Object.keys(error.response.data.errors).map(errkey => {
            return `${errkey}=> ${error.response.data.errors[errkey].map(err => err).join(',')}`
          }),
        })
        return null
      }
      return error.response.data
    }

    // 500error ise middlewareden donuyordur direkt problemdetails modeli donuyor. titlei uyari olarak veriyoruz. sagaya null donuyoruz.
    if (error.response.status === 500) {
      notification.error({ duration: 0, message: 'Error', description: error.response.data.title })
      return null
    }

    if (error.response.status === 403) {
      errorNotification403(error.response?.data)
      return null
    }

    notification.error({
      duration: 0,
      message: `Error ${error.response.status}`,
      description: NETWORK_ERROR_MESSAGE,
    })
    return null
  }
}

export async function putRequest(url, param) {
  try {
    if (url.includes('http')) {
      const response = await axios.put(url, param.values, config)
      return response.data
    }

    const response = await axios.put(`${getMicroBaseApiUrl(url)}${url}`, param.values, config)
    return response.data
  } catch (error) {
    console.error(error)

    if (error.response === undefined) {
      notification.error({
        duration: 0,
        message: 'Error',
        description: error.message,
      })
      return null
    }

    if (error.response.status === 400) {
      if (error.response.data.traceId) {
        notification.error({
          duration: 0,
          message: error.response.data.title,
          description: Object.keys(error.response.data.errors).map(errkey => {
            return `${errkey}=> ${error.response.data.errors[errkey].map(err => err).join(',')}`
          }),
        })
        return null
      }
      return error.response.data
    }

    if (error.response.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }

    if (error.response.status === 403) {
      errorNotification403(error.response?.data)
      return null
    }

    if (error.response.status === 500) {
      notification.error({ duration: 0, message: 'Error', description: error.response.data.title })
      return null
    }

    notification.error({
      duration: 0,
      message: `Error ${error.response.status}`,
      description: NETWORK_ERROR_MESSAGE,
    })
    return null
  }
}

export async function deleteRequest(url) {
  // console.log(url, param)
  try {
    if (url.includes('http')) {
      const response = await axios.delete(url, config)
      return response.data
    }

    const response = await axios.delete(`${getMicroBaseApiUrl(url)}${url}`, config)

    return response.data
  } catch (error) {
    console.error(error)
    return null
  }
}

axios.interceptors.request.use(
  c => {
    // Do something before request is sent
    // console.log('Start Ajax Call');
    if (NProgress.isStarted() === false) {
      NProgress.start()
    }
    return c
  },
  error => {
    // Do something with request error
    NProgress.done()
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  response => {
    // Do something with response data
    // console.log('Done with Ajax call');
    if (NProgress.isStarted() === true) {
      NProgress.done()
    }
    return response
  },
  error => {
    // Do something with response error
    NProgress.done()
    return Promise.reject(error)
  },
)
